import audioPlayer from '@/mixins/audio-player';
import { wait } from '@/modules/utils';

const autoNext = {
  mixins: [audioPlayer],
  props: {
    show: Boolean,
  },
  data: () => ({
    audioKey: '',
    duration: 7,
    timer: null,
    playThrough: true,
    playThroughGap: 1.5,
  }),
  methods: {
    next() {
      this.$emit('next');
    },
    setTimer(d) {
      this.timer = setTimeout(this.next, (d || this.duration) * 1000);
      this.$once('hook:beforeDestroy', () => {
        clearTimeout(this.timer);
        this.timer = null;
      });
    },
  },
  watch: {
    show: {
      handler(nv, ov) {
        if (nv && !ov) {
          if (this.playThrough) {
            this.playAudio(this.audioKey)
              .then(() => wait(this.playThroughGap))
              .then(() => {
                this.next();
              });
          } else {
            this.setTimer();
            this.playAudio(this.audioKey);
          }
        }
      },
      immediate: true,
    },
    duration(nv, ov) {
      if (!this.show || this.playThrough) return;

      if (nv > ov && this.timer) {
        clearTimeout(this.timer);
        this.setTimer(nv);
      }
    },
  },
};

export default autoNext;
